import React from 'react';
import uuidv4 from 'uuid/v4';
import {
  Segment,
  Container,
  Form,
  Button,
  Image,
  Loader
} from 'semantic-ui-react';

class TeamForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLocationInputChange = this.handleLocationInputChange.bind(this);
    this.handleLocationAdd = this.handleLocationAdd.bind(this);
    this.handleLocationDelete = this.handleLocationDelete.bind(this);

    this.state = {
      name: undefined,
      logoUrl: undefined,
      locations: []
    };
  }

  componentWillReceiveProps(nextProps) {
    const { team } = nextProps;

    if (team === undefined) {
      return;
    }

    const locations = team.locations.map(location => ({
      ...location,
      index: uuidv4()
    }));

    this.setState({
      name: team.name,
      logoUrl: team.logo_url,
      locations
    });
  }

  handleInputChange(event, { name, value }) {
    this.setState({ [name]: value });
  }

  handleSubmit() {
    const { name, logoUrl } = this.state;
    const locations = this.state.locations.map(location => ({
      id: location.id,
      name: location.name,
      address: location.address
    }));

    this.props.onSubmit({
      name,
      logo_url: logoUrl,
      locations
    });
  }

  handleLocationInputChange(event, data) {
    const { name, value } = data;
    const locationIndex = data['data-index'];
    const locations = this.state.locations.map(location => {
      if (location.index === locationIndex) {
        return { ...location, [name]: value };
      }

      return location;
    });

    this.setState({ locations });
  }

  handleLocationAdd(event) {
    event.preventDefault();

    this.setState({
      locations: this.state.locations.concat({ index: uuidv4() })
    });
  }

  handleLocationDelete(event, data) {
    event.preventDefault();

    const locations = this.state.locations.filter(
      location => data.value !== location.index
    );

    this.setState({ locations });
  }

  render() {
    const { team } = this.props;
    const { logoUrl, locations } = this.state;

    return (
      <Segment basic>
        <Loader active={!team} />
        {team && (
          <Container text>
            <Form size="large" onSubmit={this.handleSubmit}>
              <Form.Field>
                <label>Team name</label>
                <Form.Input
                  placeholder="Team name"
                  name="name"
                  defaultValue={team.name}
                  onChange={this.handleInputChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Logo URL</label>
                <Form.Input
                  placeholder="Logo URL"
                  name="logoUrl"
                  defaultValue={team.logo_url}
                  onChange={this.handleInputChange}
                />
                {logoUrl && <Image src={logoUrl} />}
              </Form.Field>

              <Form.Field>
                <label>Locations</label>
                {locations &&
                  locations.map(location => (
                    <Segment key={location.index}>
                      <Form.Group widths="equal">
                        <Form.Field>
                          <label>Label</label>
                          <Form.Input
                            placeholder="Location label"
                            name="name"
                            data-index={location.index}
                            defaultValue={location.name}
                            onChange={this.handleLocationInputChange}
                          />
                        </Form.Field>
                        <Form.Field>
                          <label>Address</label>
                          <Form.Input
                            placeholder="Location address"
                            name="address"
                            data-index={location.index}
                            defaultValue={location.address}
                            onChange={this.handleLocationInputChange}
                          />
                        </Form.Field>
                      </Form.Group>

                      <Button
                        size="mini"
                        value={location.index}
                        onClick={this.handleLocationDelete}
                      >
                        Delete
                      </Button>
                    </Segment>
                  ))}

                <Button size="mini" onClick={this.handleLocationAdd}>
                  Add location
                </Button>
              </Form.Field>

              <Button primary type="submit">
                Submit
              </Button>
            </Form>
          </Container>
        )}
      </Segment>
    );
  }
}

export default TeamForm;



// WEBPACK FOOTER //
// ./src/components/TeamForm.js